import type { Dict } from "./types";

export const mr: Dict = {
  common: {
    save: "बदल सेव्ह करा",
    saving: "सेव्ह होत आहे…",
    cancel: "रद्द करा",
    remove: "काढून टाका",
    continue: "पुढे चला",
    somethingWrong: "काहीतरी गडबड झाली",
    logOut: "लॉग आउट",
    welcomeBackGreet: "पुन्हा स्वागत आहे,",
    hiGreet: "नमस्कार,",
    statusOpen: "उघडे",
    statusInProgress: "प्रगतीपथावर",
    statusResolved: "सोडवले",
  },
  requests: {
    categoryLabel: "श्रेणी (ऐच्छिक)",
    categoryPlumbing: "प्लंबिंग",
    categoryElectrical: "इलेक्ट्रिकल",
    categoryAppliance: "उपकरण",
    categoryFurniture: "फर्निचर",
    categoryCleaning: "स्वच्छता",
    categoryPestControl: "पेस्ट कंट्रोल",
    categoryOther: "इतर",
    urgentCheckboxLabel: "हे तातडीचे आहे",
    urgentBadge: "तातडीचे",
    photoLabel: "फोटो जोडा (ऐच्छिक)",
    addPhotoBtn: "फोटो जोडा",
    removePhotoAria: "फोटो काढा",
    updatesHeading: "अपडेट्स",
    noUpdatesYet: "अजून कोणतेही अपडेट नाही.",
    addCommentPlaceholder: "एक टीप जोडा…",
    postCommentBtn: "पोस्ट करा",
    postingCommentBtn: "पोस्ट होत आहे…",
    callBtn: "कॉल करा",
    whatsappBtn: "व्हॉट्सअ‍ॅप",
  },
  nav: {
    home: "होम",
    listings: "लिस्टिंग",
    notebook: "नोटबुक",
    requests: "रिक्वेस्ट्स",
    settings: "सेटिंग्ज्",
    browse: "प्रॉपर्टी बघा",
    payments: "पेमेंट्स",
    ownerDashboard: "मालक डॅशबोर्ड",
    tenantDashboard: "भाडेकरू डॅशबोर्ड",
  },
  auth: {
    welcomeEyebrow: "स्वागत आहे",
    welcomeTitle: "ToLetBook मध्ये आपले स्वागत आहे",
    welcomeSub: "तुमच्या खात्यात लॉग इन करा, किंवा नवीन खाते तयार करा.",
    logIn: "लॉग इन करा",
    createAccount: "खाते तयार करा",
    loginTitle: "पुन्हा स्वागत आहे",
    loginSub: "तुमच्या डॅशबोर्डवर जाण्यासाठी लॉग इन करा.",
    registerTitle: "तुमचे खाते तयार करा",
    registerSub: "प्रॉपर्टी लिस्ट करा किंवा तुमचे पुढील घर शोधा — ब्रोकरशिवाय, त्रासाशिवाय.",
    passwordHint: "किमान 6 अक्षरे.",
    referralCodeLabel: "रेफरल कोड (ऐच्छिक)",
    referralCodePlaceholder: "तुमच्याकडे कोड असल्यास टाका",
    agreeTermsText: "मी ToLetBook च्या अटी व शर्ती आणि गोपनीयता धोरणाशी सहमत आहे",
    viewTermsLink: "अटी व शर्ती पहा",
    viewPrivacyLink: "गोपनीयता धोरण पहा",
    hideTermsLink: "अटी व शर्ती लपवा",
    errMustAgreeTerms: "पुढे जाण्यासाठी कृपया अटी व शर्तींशी सहमत व्हा",
    loginBusy: "लॉग इन होत आहे…",
    emailLabel: "ईमेल",
    emailPlaceholder: "you@example.com",
    passwordLabel: "पासवर्ड",
    passwordPlaceholder: "तुमचा पासवर्ड",
    errEmailPassword: "तुमचा ईमेल आणि पासवर्ड टाका",
    getStartedEyebrow: "सुरुवात करा",
    roleTitle: "तुम्ही कोण आहात ते सांगा",
    roleSub: "जेणेकरून आम्ही तुमच्यासाठी योग्य डॅशबोर्ड तयार करू शकू.",
    roleOwnerTitle: "मी प्रॉपर्टी / पीजी मालक आहे",
    roleOwnerSub: "प्रॉपर्टी लिस्ट करा, भाडेकरू सांभाळा, भाडे ट्रॅक करा",
    roleTenantTitle: "मी भाडेकरू आहे",
    roleTenantSub: "लिस्टिंग बघा, भाडे भरा, रिक्वेस्ट पाठवा",
    step1Eyebrow: "पायरी 1",
    credentialsTitle: "तुमचा लॉगिन तयार करा",
    newPasswordPlaceholder: "किमान 6 अक्षरे",
    phoneOptionalLabel: "मोबाईल नंबर (ऐच्छिक)",
    phonePlaceholder: "10 अंकी मोबाईल नंबर",
    errValidEmail: "योग्य ईमेल पत्ता टाका",
    errPasswordLength: "पासवर्ड किमान 6 अक्षरांचा असावा",
    errValidPhoneOptional: "योग्य 10 अंकी मोबाईल नंबर टाका, किंवा रिकामे सोडा",
    step2Eyebrow: "पायरी 2",
    profileTitle: "तुमच्याबद्दल थोडेसे",
    fullNameLabel: "पूर्ण नाव",
    fullNamePlaceholder: "तुमचे पूर्ण नाव",
    profileBusy: "कृपया थांबा…",
    errName: "तुमचे नाव टाका",
    step3Eyebrow: "पायरी 3",
    propertyTypeTitle: "तुम्ही काय सांभाळता?",
    propertyTypeSub: "यावरून तुम्हाला कोणता डॅशबोर्ड दिसेल हे ठरेल — हे नंतर बदलता येईल.",
    typeIndependentTitle: "इंडिपेंडंट प्रॉपर्टी",
    typeIndependentSub: "पूर्ण घरे, फ्लॅट्स, व्हिला",
    typePgTitle: "पीजी / हॉस्टेल",
    typePgSub: "बेडनुसार भाडे आकारले जाणाऱ्या शेअर्ड रूम्स",
    typeBothTitle: "दोन्ही",
    typeBothSub: "इंडिपेंडंट युनिट्स आणि पीजी रूम्सचे मिश्रण",
    almostDoneEyebrow: "जवळजवळ पूर्ण",
    cityTitle: "तुम्ही कुठे काम करता?",
    citySub: "यामुळे आम्ही तुमची लिस्टिंग जवळपासच्या भाडेकरूंना आधी दाखवू.",
    cityLabel: "शहर",
    cityPlaceholder: "उदा. मुंबई",
    bankDetailsTitle: "आम्ही तुम्हाला पैसे कसे द्यावेत?",
    bankDetailsSub: "भाडे आणि डिपॉझिट पेमेंट थेट तुम्हाला पाठवता यावेत यासाठी तुमचे बँक खाते जोडा.",
    payoutMethodUpi: "UPI आयडी",
    payoutMethodBank: "बँक खाते",
    upiIdLabel: "UPI आयडी",
    upiIdPlaceholder: "उदा. name@okhdfcbank",
    errValidUpi: "योग्य UPI आयडी टाका",
    bankAccountHolderLabel: "खातेधारकाचे नाव",
    bankAccountHolderPlaceholder: "बँक रेकॉर्डनुसार",
    bankAccountNumberLabel: "खाते क्रमांक",
    bankAccountNumberPlaceholder: "बँक खाते क्रमांक",
    bankIfscLabel: "IFSC कोड",
    bankIfscPlaceholder: "उदा. HDFC0001234",
    bankDetailsHint: "तुम्ही हे केव्हाही सेटिंग्जमधून जोडू किंवा बदलू शकता.",
    skipForNowLink: "आता वगळा",
    errValidIfsc: "योग्य IFSC कोड टाका",
    finishBusy: "सेट करत आहे…",
    finish: "पूर्ण करा",
    doneTitle: "तुम्ही तयार आहात!",
    doneSub: "तुमचा डॅशबोर्ड तयार आहे.",
    goToDashboard: "डॅशबोर्डवर जा",
    welcomeBackToast: "पुन्हा स्वागत आहे, {name}!",
    welcomeNewToast: "ToLetBook मध्ये आपले स्वागत आहे, {name}!",
    orDivider: "किंवा",
    googleNoAccountToast: "त्या Google ईमेलसाठी कोणतेही ToLetBook खाते सापडले नाही — चला तुम्हाला सेट अप करूया.",
    forgotPasswordLink: "पासवर्ड विसरलात?",
    forgotPasswordEyebrow: "पासवर्ड रीसेट करा",
    forgotPasswordTitle: "तुमचा पासवर्ड विसरलात?",
    forgotPasswordSub: "तुमचा ईमेल टाका, आम्ही तो रीसेट करण्यासाठी तुम्हाला एक लिंक पाठवू.",
    forgotPasswordSubmit: "रीसेट लिंक पाठवा",
    forgotPasswordBusy: "पाठवत आहे…",
    forgotPasswordSentTitle: "तुमचा ईमेल तपासा",
    forgotPasswordSentSub: "त्या ईमेलसाठी खाते असल्यास, आम्ही तुमचा पासवर्ड रीसेट करण्यासाठी एक लिंक पाठवली आहे.",
    resetPasswordEyebrow: "पासवर्ड रीसेट करा",
    resetPasswordTitle: "नवीन पासवर्ड निवडा",
    resetPasswordSub: "ही लिंक 1 तासासाठी वैध आहे.",
    newPasswordLabel: "नवीन पासवर्ड",
    confirmPasswordLabel: "नवीन पासवर्डची पुष्टी करा",
    errPasswordMismatch: "पासवर्ड जुळत नाहीत",
    resetPasswordSubmit: "पासवर्ड रीसेट करा",
    resetPasswordBusy: "रीसेट होत आहे…",
    resetPasswordDoneTitle: "पासवर्ड रीसेट झाला",
    resetPasswordDoneSub: "आता तुम्ही तुमच्या नवीन पासवर्डने लॉग इन करू शकता.",
  },
  settings: {
    title: "सेटिंग्ज्",
    profileMenu: "प्रोफाइल",
    reportsMenu: "रिपोर्ट्स",
    plansMenu: "प्लॅन आणि बिलिंग",
    referMenu: "रेफर करा आणि कमवा",
    appearance: "थीम",
    language: "भाषा",
    dark: "डार्क",
    light: "लाइट",
    termsTitle: "अटी व शर्ती",
    privacyTitle: "गोपनीयता धोरण",
    bankDetailsMenu: "माझी बँक डिटेल्स",
    bankDetailsHint: "या डिटेल्सचा वापर तुम्हाला थेट भाडे आणि डिपॉझिट पेमेंट पाठवण्यासाठी केला जातो. ही भाडेकरूंना कधीही दाखवली जात नाहीत.",
    bankDetailsSaved: "बँक डिटेल्स सेव्ह झाल्या",
    contactUsMenu: "आमच्याशी संपर्क साधा",
    emailUsedToLogIn: "ईमेल (लॉग इनसाठी वापरला जातो)",
    name: "नाव",
    phone: "फोन नंबर",
    phonePlaceholder: "10 अंकी मोबाईल नंबर",
    city: "शहर",
    profileUpdated: "प्रोफाइल अपडेट झाले",
    demoNotice: "इथली खाती फक्त डेमोसाठी आहेत; कोणताही तात्पुरता ईमेल आणि पासवर्ड वापरा.",
    verificationTitle: "ओळख पडताळणी",
    verificationHint: "तुमच्या प्रोफाइल आणि लिस्टिंगवर व्हेरिफाईड बॅज मिळवण्यासाठी सरकारी ओळखपत्र (पुढील आणि मागील बाजू) अपलोड करा.",
    verificationSubmit: "पडताळणीसाठी सबमिट करा",
    verificationSubmitted: "पडताळणीसाठी सबमिट केले",
    errIdPhotosRequired: "तुमच्या ओळखपत्राची पुढील आणि मागील बाजू दोन्ही जोडा",
    verificationVerified: "तुम्ही व्हेरिफाईड आहात",
    verificationPending: "पडताळणी प्रलंबित आहे",
    verificationPendingSub: "पुनरावलोकन झाल्यावर आम्ही तुम्हाला कळवू — साधारणपणे एक-दोन दिवसांत.",
    verificationRejected: "पडताळणी मंजूर झाली नाही",
    changePasswordTitle: "पासवर्ड बदला",
    currentPasswordLabel: "सध्याचा पासवर्ड",
    errCurrentPasswordRequired: "तुमचा सध्याचा पासवर्ड टाका",
    passwordChanged: "पासवर्ड बदलला",
    changePasswordButton: "पासवर्ड अपडेट करा",
  },
  notifications: {
    title: "नोटिफिकेशन",
    enabledToast: "नोटिफिकेशन सुरू केले",
    disabledToast: "नोटिफिकेशन बंद केले",
    couldNotEnableToast: "नोटिफिकेशन सुरू करता आले नाही",
    notConfigured: "या सर्व्हरवर नोटिफिकेशन अजून सेटअप केलेले नाही",
    deniedHint: "तुमच्या डिव्हाइस सेटिंग्जमध्ये या अ‍ॅपसाठी नोटिफिकेशन ब्लॉक केलेले आहे.",
    markAllRead: "सर्व वाचले म्हणून चिन्हांकित करा",
    emptyState: "अजून कोणतेही नोटिफिकेशन नाही.",
  },
  refer: {
    title: "रेफर करा आणि कमवा",
    heroTitle: "1 महिना द्या, 1 महिना मिळवा",
    heroSub: "तुमच्या मित्राला ToLetBook वर आमंत्रित करा. त्यांनी अ‍ॅप डाउनलोड करून सुरुवात केल्यावर — मालक म्हणून त्यांची पहिली प्रॉपर्टी लिस्ट केली, किंवा भाडेकरू म्हणून त्यांचा पहिला कॉन्टॅक्ट अनलॉक केला — तरी तुम्हा दोघांनाही 1 महिन्याचे Pro मोफत मिळेल.",
    yourCodeLabel: "तुमचा रेफरल कोड",
    shareButton: "आमंत्रण शेअर करा",
    copiedToast: "रेफरल लिंक कॉपी झाली",
    statsReferred: "{count} आमंत्रित",
    statsRewarded: "{count} जणांना बक्षीस मिळाले",
    statsRemaining: "{count} मोफत महिने शिल्लक",
    howItWorksTitle: "हे कसे कार्य करते",
    step1: "तुमचा कोड किंवा लिंक मित्रासोबत शेअर करा",
    step2: "ते ToLetBook डाउनलोड करतात आणि साइन अप करतात",
    step3: "ते मालक म्हणून पहिली प्रॉपर्टी लिस्ट करतात, किंवा भाडेकरू म्हणून पहिला कॉन्टॅक्ट अनलॉक करतात — तुम्हा दोघांनाही 1 महिन्याचे Pro मोफत मिळेल",
    historyTitle: "तुमचे रेफरल्स",
    emptyState: "अजून कोणतेही रेफरल नाही — सुरुवात करण्यासाठी तुमचा कोड शेअर करा",
    statusPending: "त्यांच्या पहिल्या लिस्टिंगची वाट पाहत आहे",
    statusRewarded: "बक्षीस मिळाले — 1 महिना मोफत",
    statusCapped: "त्यांना बक्षीस मिळाले — तुमची मर्यादा संपली",
    shareMessage: "माझ्यासोबत ToLetBook वर सामील व्हा! साइन अप करताना माझा रेफरल कोड {code} वापरा — आपल्या दोघांनाही 1 महिन्याचे Pro मोफत मिळेल.",
  },
  ownerTerms: {
    intro: "ToLetBook वापरून तुम्ही या अटींशी सहमत होता.",
    bullet1: "ToLetBook मार्फत केलेले भाडे आणि डिपॉझिटचे पेमेंट Razorpay मार्फत प्रोसेस केले जाते. ToLetBook ही बँक नाही आणि Razorpay च्या पुष्टीच्या पलीकडे कोणत्याही निकालाची हमी देत नाही.",
    bullet2: "तुम्ही टाकलेली प्रॉपर्टी, भाडेकरू आणि पेमेंटची माहिती बरोबर असण्याची जबाबदारी तुमची आहे.",
    bullet3: "तुम्ही टाकलेली प्रॉपर्टी, भाडेकरू आणि पेमेंटची माहिती फक्त या डेमोसाठी साठवली जाते, कोणत्याही तिसऱ्या पक्षाशी शेअर केली जात नाही.",
    bullet4: "रिपोर्ट्स आणि नोटबुकमधील आकडे तुम्ही टाकलेल्या डेटावरून थेट काढले जातात — ऑडिट किंवा पडताळणी केलेले नाहीत.",
    bullet5: "नकाशा आणि लोकेशन सुविधा Google Maps कडून दिल्या जातात, ज्या Google च्या स्वतःच्या अटींच्या अधीन आहेत.",
  },
  tenantTerms: {
    intro: "ToLetBook वापरून तुम्ही या अटींशी सहमत होता.",
    bullet1: "ToLetBook मार्फत केलेले भाडे आणि डिपॉझिटचे पेमेंट Razorpay मार्फत प्रोसेस केले जाते. ToLetBook ही बँक नाही आणि Razorpay च्या पुष्टीच्या पलीकडे कोणत्याही निकालाची हमी देत नाही.",
    bullet2: "तुम्ही दिलेली माहिती बरोबर असण्याची जबाबदारी तुमची आहे.",
    bullet3: "तुम्ही टाकलेली प्रॉपर्टी, भाडेकरू आणि पेमेंटची माहिती फक्त या डेमोसाठी साठवली जाते, कोणत्याही तिसऱ्या पक्षाशी शेअर केली जात नाही.",
    bullet4: "दाखवलेले आकडे तुम्ही किंवा तुमच्या मालकाने टाकलेल्या डेटावरून थेट काढले जातात — ऑडिट किंवा पडताळणी केलेले नाहीत.",
    bullet5: "नकाशा आणि लोकेशन सुविधा Google Maps कडून दिल्या जातात, ज्या Google च्या स्वतःच्या अटींच्या अधीन आहेत.",
  },
  ownerHome: {
    sectionTitlePg: "तुमचे पीजी",
    sectionTitleProperties: "तुमच्या प्रॉपर्टी",
    thisMonth: "या महिन्यात",
    pctCollected: "{pct}% जमा झाले",
    received: "मिळाले",
    pending: "बाकी",
    remindAll: "सर्वांना रिमाइंड करा",
    remindersSent: "{count} भाडेकरूंना रिमाइंडर पाठवला",
    couldNotSendReminders: "रिमाइंडर पाठवता आले नाहीत",
    bedOccupancy: "बेड ऑक्युपन्सी",
    bedsFraction: "{filled}/{total} बेड",
    acrossPg: "एकूण {count} पीजी {unit}",
    pgUnitSingular: "प्रॉपर्टी",
    pgUnitPlural: "प्रॉपर्टीज्",
    totalCount: "एकूण {count}",
    addPropertyAria: "प्रॉपर्टी जोडा",
    addUnitFab: "युनिट जोडा",
    sendWhatsappReceiptBtn: "WhatsApp पावती पाठवा",
    directUpiPayLinkBtn: "डायरेक्ट UPI पे लिंक",
    whatsappReceiptMessage: "नमस्कार {tenant}, {property} साठी तुमची भाड्याची पावती: {amount} ({status}). - {owner}, ToLetBook मार्फत",
    upiPayLinkMessage: "नमस्कार {tenant}, कृपया {property} चे या महिन्याचे भाडे ({amount}) UPI द्वारे भरा: {link} - {owner}, ToLetBook मार्फत",
    noTenantPhone: "या भाडेकरूचा फोन नंबर नोंदवलेला नाही",
    noUpiIdSet: "आधी सेटिंग्जमध्ये तुमचा UPI ID टाका",
    tabProperty: "प्रॉपर्टी",
    tabPg: "पीजी",
    emptyNoProperties: "अजून कोणतीही प्रॉपर्टी नाही. पहिली प्रॉपर्टी जोडण्यासाठी + वर टॅप करा.",
    emptyNoIndependent: "अजून कोणतीही इंडिपेंडंट प्रॉपर्टी नाही.",
    emptyNoPg: "अजून कोणतीही पीजी प्रॉपर्टी नाही.",
    emptyNoCommercial: "अजून कोणतीही कमर्शियल प्रॉपर्टी नाही.",
    filterAll: "सर्व",
    filterResidential: "रेसिडेन्शियल",
    filterCommercial: "कमर्शियल",
    filterPg: "PG / हॉस्टेल",
    sqftSuffix: "चौ. फूट",
    listedOnMarketplace: "मार्केटप्लेसवर लिस्ट केले",
    removedFromMarketplace: "मार्केटप्लेसवरून काढले",
    couldNotUpdateListing: "लिस्टिंग अपडेट होऊ शकले नाही",
    rentUpdated: "भाडे अपडेट झाले",
    couldNotUpdateRent: "भाडे अपडेट होऊ शकले नाही",
    maintenanceUpdated: "मेंटेनन्स अपडेट झाले",
    couldNotUpdateMaintenance: "मेंटेनन्स अपडेट होऊ शकले नाही",
    paid: "भरले",
    tenantLabel: "भाडेकरू",
    perMonth: "/महिना",
    phoneLabel: "फोन",
    noPhoneOnFile: "फोन नंबर नोंदवलेला नाही",
    aadhaarLabel: "आधार",
    depositLabel: "डिपॉझिट",
    moveInDateLabel: "मूव्ह-इन तारीख",
    hideManageOptions: "मॅनेज पर्याय लपवा",
    manage: "मॅनेज करा",
    manageHouses: "घरे मॅनेज करा",
    rentalAgreement: "रेंटल अ‍ॅग्रीमेंट",
    rentalReceipts: "रेंटल पावत्या",
    modifyRent: "भाडे बदला",
    maintenanceMenu: "मेंटेनन्स",
    removeTenant: "भाडेकरू काढा",
    newRentLabel: "नवीन भाडे / महिना",
    save: "सेव्ह करा",
    maintenancePerMonthLabel: "मेंटेनन्स / महिना",
    vacantBadge: "रिकामे",
    expectedRentLabel: "अपेक्षित भाडे",
    depositSuffix: " · डिपॉझिट {amount}",
    maintenanceLine: "+ {amount}/महिना मेंटेनन्स",
    listOnToLet: "TO-LET मार्केटप्लेसवर लिस्ट करा",
    liveVisible: "लाइव्ह · भाडेकरूंना दिसते",
    notListedYet: "अजून लिस्ट केलेले नाही",
    toggleToLetAria: "TO-LET टॉगल करा",
    addTenantButton: "भाडेकरू जोडा",
    occBoys: "बॉईज पीजी",
    occGirls: "गर्ल्स पीजी",
    occCoEd: "को-एड पीजी",
    occDefault: "पीजी",
    listVacantBedsToLet: "रिकामे बेड TO-LET वर लिस्ट करा",
    fullyOccupied: "पूर्ण भरलेले · रिकामे बेड नाहीत",
  },
  ownerListings: {
    propertyAdded: "प्रॉपर्टी जोडली",
    upgradeToastMsg: "तुम्ही तुमच्या प्लॅनची लिस्टिंग मर्यादा गाठली आहे — अपग्रेड पर्यायांकडे पुनर्निर्देशित करत आहे.",
    heading: "माझ्या प्रॉपर्टी",
    addLink: "+ जोडा ›",
    emptyState: "अजून कोणतीही प्रॉपर्टी नाही — पहिली प्रॉपर्टी जोडा.",
    confirmDelete: '"{label}" डिलीट करायचे? हे परत करता येणार नाही.',
    propertyDeleted: "प्रॉपर्टी डिलीट झाली",
    confirmDeleteHouse: '"{label}" काढून टाकायचे? हे परत आणता येणार नाही.',
    houseRemoved: "घर काढून टाकले",
    houseUpdated: "घराची माहिती अपडेट झाली",
    listedOnMarketplace: "मार्केटप्लेसवर लिस्ट केले",
    removedFromMarketplace: "मार्केटप्लेसवरून काढले",
    couldNotUpdateListing: "लिस्टिंग अपडेट होऊ शकले नाही",
    vacantBedsFraction: "{vacant} / {total} रिकामे",
    listOnToLet: "TO-LET मार्केटप्लेसवर लिस्ट करा",
    listVacantBedsToLet: "रिकामे बेड TO-LET वर लिस्ट करा",
    liveVisible: "लाइव्ह · भाडेकरूंना दिसते",
    notListedYet: "अजून लिस्ट केलेले नाही",
    toggleToLetAria: "TO-LET टॉगल करा",
    moreOptionsAria: "आणखी पर्याय",
    editDetails: "डिटेल्स एडिट करा",
    deleteProperty: "प्रॉपर्टी डिलीट करा",
    expectedRentLabel: "अपेक्षित भाडे",
    depositLabel: "डिपॉझिट",
    noPhoneOnFile: "फोन नंबर नोंदवलेला नाही",
    perMonth: "/महिना",
    endTenancyButton: "टेनन्सी संपवा",
    editTenantButton: "भाडेकरू मॉडिफाय करा",
    saveTenantButton: "बदल सेव्ह करा",
    tenantAdded: "भाडेकरू जोडला",
    tenantUpdated: "भाडेकरूची माहिती अपडेट झाली",
    roomAdded: "खोली जोडली",
    couldNotAddRoom: "खोली जोडता आली नाही",
    addTenantLink: "+ भाडेकरू जोडा",
    installAppPromptTitle: "{name} ने अजून ToLetBook इंस्टॉल केलेले नाही",
    installAppPromptBody: "अ‍ॅप शेअर करा जेणेकरून ते त्यांचा अ‍ॅग्रीमेंट बघू शकतील आणि मूव्ह-इन माहिती पूर्ण करू शकतील.",
    notifyTenantPromptTitle: "WhatsApp वर {name} ला कळवा",
    notifyTenantPromptBody: "हे शेअर करा जेणेकरून ते अ‍ॅप उघडून मूव्ह-इन माहिती पूर्ण करू शकतील.",
    shareOnWhatsappBtn: "💬 WhatsApp वर शेअर करा",
    installAppWhatsappMessage: "नमस्कार, मी ToLetBook कडून {owner} आहे. मी तुम्हाला \"{property}\" साठी भाडेकरू म्हणून जोडले आहे. कृपया तुमचे भाडे, अ‍ॅग्रीमेंट बघण्यासाठी आणि मूव्ह-इन माहिती पूर्ण करण्यासाठी अ‍ॅप इंस्टॉल करा: {link}",
    notifyTenantWhatsappMessage: "नमस्कार, मी ToLetBook कडून {owner} आहे. मी तुम्हाला \"{property}\" साठी भाडेकरू म्हणून जोडले आहे. कृपया तुमचे भाडे, अ‍ॅग्रीमेंट बघण्यासाठी आणि मूव्ह-इन माहिती पूर्ण करण्यासाठी अ‍ॅप उघडा: {link}",
    editButton: "एडिट करा",
    deleteButton: "डिलीट करा",
    perBed: "{amount}/बेड",
    priceTiers: "{count} प्राइस टियर",
    occupiedFraction: "{occupied}/{total} भरलेले",
    occupiedBadge: "भरलेले",
    vacantBadge: "रिकामे",
    rentalAgreementButton: "रेंटल अ‍ॅग्रीमेंट",
    rentalReceiptsButton: "भाड्याच्या पावत्या",
    noReceiptsYet: "अद्याप कोणतीही भरलेली पावती नाही.",
    receiptsBackLink: "‹ मागे",
    loadingReceipts: "लोड होत आहे…",
  },
  assignTenantForm: {
    contactPickerUnsupported: "या डिव्हाइस/ब्राउझरवर कॉन्टॅक्ट पिकर सपोर्ट होत नाही",
    errNameRequired: "भाडेकरूचे नाव आवश्यक आहे",
    newTenant: "नवीन भाडेकरू",
    existingTenant: "आधीचा भाडेकरू",
    addFromContacts: "कॉन्टॅक्ट्समधून जोडा",
    emptyExistingTenants: "तुमच्या प्रॉपर्टीवर अजून दुसरे भाडेकरू नाहीत.",
    noPhoneOnFile: "फोन नंबर नोंदवलेला नाही",
    tenantNameLabel: "भाडेकरूचे नाव",
    phoneLabel: "फोन (नोंदणीकृत असल्यास त्यांच्या ToLetBook खात्याशी जुळेल)",
    phonePlaceholder: "10 अंकी नंबर",
    aadhaarLabel: "आधार (ऐच्छिक)",
    aadhaarPhotosLabel: "आधार फोटो (ऐच्छिक)",
    aadhaarFront: "पुढील बाजू",
    aadhaarBack: "मागील बाजू",
    removeAadhaarPhotoAria: "फोटो काढा",
    rentLabel: "भाडे / महिना",
    depositLabel: "डिपॉझिट",
    dateOfOccupancyLabel: "राहायला आल्याची तारीख",
    dateHint: "जर ते आधीपासून इथे राहत असतील, तर ते खरोखर कधी राहायला आले ती तारीख निवडा — आजची नाही.",
    rentDueDayLabel: "भाडे देय तारीख",
    rentDueDayHint: "महिन्यातील भाडे देय तारीख (1–31). डीफॉल्ट राहायला आल्याची तारीख असते.",
    noticePeriodLabel: "नोटीस कालावधी (दिवस)",
    noticePeriodHint: "भाडेकरूने जागा रिकामी करण्यापूर्वी किती दिवस आधी नोटीस द्यावी लागेल. डीफॉल्ट 60 दिवस (2 महिने) असतो.",
    addTenantButton: "भाडेकरू जोडा",
  },
  addPropertyForm: {
    errNameRequired: "प्रॉपर्टीला नाव द्या",
    errLocalityRequired: "परिसर टाका",
    errCityRequired: "शहर टाका",
    errStateRequired: "राज्य निवडा",
    errPincodeRequired: "पिनकोड टाका",
    errFurnishingRequired: "फर्निशिंग स्थिती निवडा",
    errCommunityTypeRequired: "कम्युनिटी प्रकार निवडा",
    errRentRequired: "अपेक्षित भाडे टाका",
    errDepositRequired: "अपेक्षित डिपॉझिट टाका",
    upgradeNowBtn: "आता अपग्रेड करा",
    heading: "प्रॉपर्टी जोडा",
    localityLabel: "परिसर",
    localityPlaceholder: "उदा. इंदिरानगर, बंगळुरू",
    cityLabel: "शहर",
    cityPlaceholder: "उदा. बंगळुरू",
    stateLabel: "राज्य",
    statePlaceholder: "राज्य निवडा",
    pincodeLabel: "पिनकोड",
    pincodePlaceholder: "6 अंकी पिनकोड",
    chipIndependent: "इंडिपेंडंट",
    chipPgHostel: "पीजी / हॉस्टेल",
    chipCommercial: "कमर्शियल",
    propertyNameLabel: "प्रॉपर्टीचे नाव",
    propertyNamePlaceholder: "उदा. 3, रोझवूड अपार्टमेंट्स",
    typeLabel: "प्रकार",
    expectedRentLabel: "अपेक्षित भाडे",
    expectedDepositLabel: "अपेक्षित डिपॉझिट",
    maintenanceLabel: "मेंटेनन्स / महिना (ऐच्छिक)",
    maintenancePlaceholder: "उदा. 1500",
    multiUnitChip: "या प्रॉपर्टीमध्ये अनेक घरे आहेत",
    multiUnitHint: "भाड्यासाठी एकापेक्षा जास्त स्वतंत्र घरे/फ्लॅट्स असलेल्या कंपाउंड किंवा इमारतीसाठी — प्रत्येकाचे स्वतःचे भाडे, डिपॉझिट आणि भाडेकरू असेल.",
    commercialDetailsHeading: "कमर्शियल तपशील",
    carpetAreaLabel: "कारपेट एरिया (चौ. फूट)",
    builtUpAreaLabel: "बिल्ट-अप एरिया (चौ. फूट)",
    lockInMonthsLabel: "लॉक-इन कालावधी (महिने)",
    rentEscalationPercentLabel: "भाडेवाढ (%)",
    rentEscalationYearsLabel: "किती वर्षांनी वाढ",
    possessionStatusLabel: "पझेशन स्थिती",
    possession_ready: "लगेच उपलब्ध",
    possession_under_fitout: "फिट-आउट सुरू आहे",
    washroomTypeLabel: "वॉशरूम",
    washroom_attached: "अटॅच्ड",
    washroom_shared: "शेअर्ड",
    commercialAmenitiesLabel: "सुविधा",
    powerBackupChip: "पॉवर बॅकअप",
    powerLoadDetailsLabel: "पॉवर बॅकअप तपशील (ऐच्छिक)",
    powerLoadDetailsPlaceholder: "उदा. 3-फेज, 100% DG बॅकअप",
    parkingSpotsLabel: "राखीव पार्किंग (कार/बाइक)",
    gstChip: "भाड्यावर 18% GST लागू",
    frontageChip: "फ्रंटेज / साइनेज हक्क",
    seatsCountLabel: "सीट्स",
    cabinsCountLabel: "केबिन",
    meetingRoomsCountLabel: "मीटिंग रूम्स",
    housesHeading: "घरे",
    addHouseLink: "+ घर जोडा ›",
    houseNameLabel: "घराचे नाव",
    hasExistingTenantChip: "या प्रॉपर्टीमध्ये आधीच भाडेकरू आहे",
    tenantNameLabel: "भाडेकरूचे नाव",
    phoneLabel: "फोन (नोंदणीकृत असल्यास त्यांच्या ToLetBook खात्याशी जुळेल)",
    phonePlaceholder: "10 अंकी नंबर",
    aadhaarLabel: "आधार (ऐच्छिक)",
    dateOfOccupancyLabel: "राहायला आल्याची तारीख",
    dateHint: "ते खरोखर कधी राहायला आले — भाडे आणि डिपॉझिटसाठी वरील अपेक्षित मूल्ये वापरली जातील.",
    occupancyLabel: "ऑक्युपन्सी",
    occBoys: "बॉईज",
    occGirls: "गर्ल्स",
    occCoEd: "को-एड",
    roomsHeading: "रूम्स",
    addRoomLink: "+ रूम जोडा ›",
    sharingTypeLabel: "शेअरिंग प्रकार",
    rentPerBedLabel: "भाडे/बेड",
    depositPerBedLabel: "डिपॉझिट/बेड",
    bedsLabel: "बेड",
    mealPlanLabel: "जेवण समाविष्ट",
    preferredTenantsLabel: "पसंतीचे भाडेकरू",
    meal_breakfast: "ब्रेकफास्ट",
    meal_lunch: "लंच",
    meal_dinner: "डिनर",
    tenantType_student: "स्टुडंट",
    tenantType_professional: "वर्किंग प्रोफेशनल",
    roomAc: "एसी",
    roomAttachedBathroom: "अटॅच्ड बाथरूम",
    addPropertyButton: "प्रॉपर्टी जोडा",
  },
  ownerLedgers: {
    justNow: "आत्ताच",
    minsAgo: "{mins} मिनिटांपूर्वी",
    hoursAgo: "{hours} तासांपूर्वी",
    daysAgo: "{days} दिवसांपूर्वी",
    emptyNoProperty: "नोटबुक ट्रॅक करण्यासाठी आधी एक प्रॉपर्टी जोडा.",
    heading: "नोटबुक",
    emptyNoTenants: "इथे अजून कोणी भाडेकरू नाही.",
    markedPaid: "भरले म्हणून मार्क केले",
    reminderSent: "भाडेकरूला रिमाइंडर पाठवला",
    emptyNoActiveTenants: "इथे अजून कोणी अ‍ॅक्टिव्ह भाडेकरू नाही.",
    otherCategory: "इतर",
    pastTenantsHeading: "जुने भाडेकरू · {count}",
    rentLedgerLabel: "भाडे लेजर · मागील 12 महिने",
    paidFraction: "{paid}/{total} भरले",
    entriesLabel: "एंट्री",
    rentPaid: "भाडे मिळाले",
    rentDue: "भाडे बाकी",
    markReceived: "मिळाले म्हणून मार्क करा (रोख)",
    markingBusy: "मार्क होत आहे…",
    remindAgain: "🔔 पुन्हा रिमाइंड करा",
    remind: "🔔 रिमाइंड करा",
    sendingBusy: "पाठवत आहे…",
    remindedAgo: "{time} रिमाइंड केले",
    closeButton: "‹ बंद करा",
    refundLabel: "रिफंड",
    refundedAmount: "{amount} रिफंड केले",
  },
  ownerReports: {
    emptyState: "अजून लेजरमध्ये काही हालचाल नाही — वसुली सुरू करण्यासाठी भाडेकरू जोडा.",
    heading: "रिपोर्ट्स",
    collected: "जमा झाले",
    pending: "बाकी",
    paidOnRecord: "रेकॉर्डवर भरलेले",
    collectionsByMonth: "महिनानिहाय वसुली",
    monthTooltip: "{month}: {collected} जमा, {pending} बाकी",
    byProperty: "प्रॉपर्टीनुसार",
    pendingAmount: "{amount} बाकी",
    exportCsvButton: "लेजर CSV म्हणून एक्सपोर्ट करा",
    hint: "प्रत्येक रांग लेजर एंट्रीशी जोडलेली आहे — इथे वेगळे आकडे जोडलेले नाहीत.",
  },
  ownerRequests: {
    visitRequestsHeading: "व्हिजिट रिक्वेस्ट",
    newCount: "{count} नवीन",
    emptyNoVisits: "अजून कोणतीही व्हिजिट रिक्वेस्ट नाही.",
    maintenanceRequestsHeading: "मेंटेनन्स रिक्वेस्ट",
    emptyNoRequests: "अजून कोणतीही रिक्वेस्ट पाठवलेली नाही.",
    noDetailsProvided: "कोणतीही माहिती दिलेली नाही",
    startWork: "काम सुरू करा",
    markResolved: "सोडवले म्हणून मार्क करा",
    requestUpdated: "रिक्वेस्ट अपडेट झाली",
    visitConfirmed: "व्हिजिट कन्फर्म झाली",
    visitDeclined: "व्हिजिट नाकारली",
    noPhoneOnFile: "फोन नंबर नोंदवलेला नाही",
    visitLine: "{property} · {date} रोजी {time} वाजता",
    declineButton: "नाकारा",
    confirmButton: "कन्फर्म करा",
    statusOpen: "उघडे",
    statusInProgress: "प्रगतीपथावर",
    statusResolved: "सोडवले",
    visitStatusPending: "प्रलंबित",
    visitStatusConfirmed: "कन्फर्म",
    visitStatusDeclined: "नाकारलेले",
    visitStatusCancelled: "रद्द",
    vacateRequestsHeading: "रिकामी करण्याच्या नोटीस",
    emptyNoVacates: "अजून रिकामी करण्याच्या कोणत्याही नोटीस नाहीत.",
    vacateLine: "{property} · {date} रोजी रिकामी होणार",
    noticeGivenLine: "{date} रोजी नोटीस दिली",
    acknowledgeButton: "मान्य करा",
    vacateAcknowledged: "रिकामी करण्याची नोटीस मान्य केली",
    vacateStatusPending: "प्रलंबित",
    vacateStatusAcknowledged: "मान्य केली",
    vacateStatusCancelled: "रद्द",
  },
  editPropertyForm: {
    errNameRequired: "प्रॉपर्टीला नाव द्या",
    propertyUpdated: "प्रॉपर्टी अपडेट झाली",
    couldNotUpdate: "प्रॉपर्टी अपडेट होऊ शकली नाही",
    localityLabel: "परिसर",
    propertyNameLabel: "प्रॉपर्टीचे नाव",
    typeLabel: "प्रकार",
    residentialGroup: "रेसिडेन्शियल",
    commercialGroup: "कमर्शियल",
    expectedRentLabel: "अपेक्षित भाडे",
    expectedDepositLabel: "अपेक्षित डिपॉझिट",
    maintenanceLabel: "मेंटेनन्स / महिना (ऐच्छिक)",
    occupancyLabel: "ऑक्युपन्सी",
    occBoys: "बॉईज",
    occGirls: "गर्ल्स",
    occCoEd: "को-एड",
    facilitiesLabel: "सुविधा",
    facility_wifi: "वाय-फाय",
    facility_meals: "जेवण",
    facility_laundry: "लॉन्ड्री",
    facility_powerBackup: "पॉवर बॅकअप",
    facility_cctv: "सीसीटीव्ही",
    facility_parking: "पार्किंग",
    facility_ac: "एसी",
    facility_tv: "टीव्ही",
    facility_washingMachine: "वॉशिंग मशीन",
    perHouseFurnishingHint: "फर्निशिंग प्रत्येक घरासाठी वेगळी सेट केली जाते — खाली प्रत्येक घर उघडून सेट करा.",
    furnishingStatusLabel: "फर्निशिंग",
    furnishing_unfurnished: "अनफर्निश्ड",
    furnishing_semi_furnished: "सेमी-फर्निश्ड",
    furnishing_fully_furnished: "फुली फर्निश्ड",
    commercialFurnishing_unfurnished: "बेअर शेल",
    commercialFurnishing_semi_furnished: "वॉर्म शेल",
    commercialFurnishing_fully_furnished: "फुली फर्निश्ड",
    communityTypeLabel: "कम्युनिटी प्रकार",
    community_gated: "गेटेड कम्युनिटी",
    community_semi_gated: "सेमी गेटेड कम्युनिटी",
    community_villa: "व्हिला",
    community_apartment: "अपार्टमेंट",
    community_independent: "इंडिपेंडंट",
    floorNumberLabel: "मजला",
    floorNumberPlaceholder: "उदा. 3 किंवा ग्राउंड",
    floorChipLabel: "मजला {floor}",
    furnishingItemsLabel: "फर्निचर आणि उपकरणे",
    furnishingItemsHint: "भाडेकरूला प्रत्येक किती मिळतील ते नमूद करा.",
    item_fan: "पंखे",
    item_light: "दिवे",
    item_ac: "एसी",
    item_fridge: "फ्रीज",
    item_washingMachine: "वॉशिंग मशीन",
    item_sofa: "सोफा",
    item_bed: "बेड",
    item_heater: "वॉटर हीटर (बाथरूम)",
    item_chimney: "चिमणी (किचन)",
    addFurnitureItemPlaceholder: "+ फर्निचर / उपकरण जोडा",
    customItemNamePlaceholder: "उदा. स्टडी टेबल",
    addCustomItemBtn: "+ आणखी वस्तू जोडा",
  },
  endTenancyForm: {
    tenancyEnded: "टेनन्सी संपली — रिफंडची माहिती भाडेकरूला पाठवली",
    couldNotEnd: "टेनन्सी संपवता आली नाही",
    heading: "टेनन्सी संपवा — {name}",
    dateOfExitLabel: "जाण्याची तारीख",
    depositPaidLabel: "भरलेले डिपॉझिट",
    deductionsLabel: "कपात (नुकसान, बाकी रक्कम इ.)",
    deductionNoteLabel: "कपातीची नोंद (ऐच्छिक)",
    deductionNotePlaceholder: "उदा. भिंतीचा रंग दुरुस्ती",
    refundableDepositLabel: "परत मिळणारे डिपॉझिट",
    confirmButton: "कन्फर्म करा आणि टेनन्सी संपवा",
    endingBusy: "संपवत आहे…",
  },
  propertyPhotos: {
    uploadFailed: "अपलोड अयशस्वी झाले",
    photoRemoved: "फोटो काढला",
    couldNotRemove: "फोटो काढता आला नाही",
    removePhotoAria: "फोटो काढा",
  },
  photoStager: {
    photosLabel: "फोटो (ऐच्छिक)",
    couldNotRead: "तो फोटो वाचता आला नाही",
    removePhotoAria: "फोटो काढा",
  },
  photoPickerButtons: {
    addPhotoTitle: "फोटो जोडा",
    takePhoto: "📷 फोटो काढा",
    chooseFromFiles: "🖼 फाइल्समधून निवडा",
  },
  ownerPlans: {
    title: "प्लॅन्स",
    currentPlanLabel: "सध्याचा प्लॅन",
    trialBadge: "मोफत प्रीमियम ट्रायल",
    trialEndsOn: "ट्रायल {date} रोजी संपेल",
    renewsOn: "{date} रोजी रिन्यू होईल",
    listingsUsed: "{cap} पैकी {used} लिस्टिंग वापरले",
    billingMonthly: "मासिक",
    billingYearly: "वार्षिक · ~16% बचत",
    basicName: "बेसिक",
    proName: "प्रो",
    premiumName: "प्रीमियम",
    mostPopular: "सर्वाधिक लोकप्रिय",
    powerOwners: "पॉवर मालकांसाठी",
    basicSub: "नुकतीच सुरुवात करणाऱ्या मालकांसाठी",
    proSub: "काही प्रॉपर्टीज असलेल्या मालकांसाठी",
    premiumSub: "अनेक प्रॉपर्टीज सांभाळणाऱ्या मालकांसाठी",
    featListing1: "1 अ‍ॅक्टिव्ह लिस्टिंग",
    featListing3: "3 पर्यंत अ‍ॅक्टिव्ह लिस्टिंग",
    featListingUnlimited: "अमर्यादित लिस्टिंग",
    featEnquiries: "भाडेकरू चौकशी आणि व्हिजिट रिक्वेस्ट",
    featLedger: "भाडे वसुली आणि डिजिटल लेजर",
    featAgreement: "सेल्फ-सर्व्ह रेंटल अ‍ॅग्रीमेंट जनरेटर — लवकरच येत आहे",
    featMarketplace: "TO-LET मार्केटप्लेसवर दिसते",
    featEverythingBasic: "बेसिकमधील सर्व काही",
    featEverythingPro: "प्रोमधील सर्व काही",
    featMarketplaceSwitch: "TO-LET मार्केटप्लेस स्विच — कधीही लाईव्ह करा",
    featFeatured: "सर्चमध्ये फीचर्ड प्लेसमेंट",
    featPriority: "मिळत्याजुळत्या प्रॉपर्टी सूचनांमध्ये प्राधान्य",
    featTopListing: "टॉप लिस्टिंग — मार्केटप्लेस सर्चमध्ये सर्वात वर पिन केलेले",
    featPriorityAgreement: "प्राधान्य रेंटल अ‍ॅग्रीमेंट सेवा (कायदेशीर पडताळणी केलेली, जलद टर्नअराउंड) — लवकरच येत आहे",
    featPriorityVerification: "प्राधान्य ओळख-पडताळणी पुनरावलोकन",
    featPrioritySupport: "प्राधान्य सपोर्ट",
    currentPlanBtn: "सध्याचा प्लॅन",
    switchToBtn: "{plan} वर स्विच करा",
    noChargeNote: "अजून पेमेंटची गरज नाही — बिलिंग सेट होईपर्यंत प्लॅन बदलणे मोफत आहे.",
    switchedToast: "{plan} प्लॅनवर स्विच केले",
    switchFailedToast: "प्लॅन स्विच करता आला नाही",
    trialActiveNote: "तुम्ही मोफत प्रीमियम ट्रायलवर आहात — तो संपेपर्यंत प्रत्येक प्रीमियम फीचर अनलॉक आहे.",
    cancelPlanBtn: "प्लॅन रद्द करा",
    securePaymentNote: "पेमेंट Razorpay द्वारे सुरक्षितपणे प्रोसेस केले जाते.",
  },
  tenantHome: {
    moveOutSettlement: "मूव्ह-आउट सेटलमेंट",
    yourLastPlace: "तुमची मागील जागा",
    depositPaid: "भरलेले डिपॉझिट",
    deductionsLabel: "कपात",
    refundableDeposit: "परत मिळणारे डिपॉझिट",
    exitedOn: "{date} रोजी सोडले",
    noActiveTenancyLine1: "तुमची सध्या कोणतीही अ‍ॅक्टिव्ह टेनन्सी नाही.",
    noActiveTenancyLine2: "जागा शोधण्यासाठी लिस्टिंग बघा, किंवा राहायला गेल्यावर तुमच्या मालकाला तुम्हाला जोडायला सांगा.",
    welcomeTitle: "ToLetBook मध्ये आपले स्वागत आहे!",
    welcomeSub: "तुमच्यासाठी भाड्याची प्रॉपर्टी शोधूया.",
    browsePropertiesBtn: "प्रॉपर्टी बघा",
    rentForMonth: "{month} चे भाडे",
    paidStatus: "भरले",
    dueStatus: "बाकी",
    overdueStatus: "ओव्हरड्यू",
    dueInDays: "{count} दिवसांत देय",
    dueTodayLabel: "आज देय आहे",
    overdueByDays: "{count} दिवस ओव्हरड्यू",
    reminderBanner: "🔔 या पेमेंटबद्दल तुमच्या मालकाने रिमाइंडर पाठवला आहे",
    paidCheck: "✓ भरले",
    onDate: "{date} रोजी",
    viaMode: "{mode} द्वारे",
    receiptBtn: "पावती",
    payingBtn: "भरत आहे…",
    payAmount: "{amount} भरा",
    paymentRecordedToast: "पेमेंट नोंदवले गेले",
    ownerLabel: "मालक",
    callOwnerAria: "मालकाला कॉल करा",
    raiseRequest: "रिक्वेस्ट पाठवा",
    viewLease: "अ‍ॅग्रीमेंट बघा",
    receiptsNav: "पावत्या",
    browseRooms: "रूम्स बघा",
    openRequestsHeading: "उघड्या रिक्वेस्ट",
    viewAll: "सर्व बघा",
    noOpenRequests: "कोणतीही उघडी रिक्वेस्ट नाही.",
    noDetailsProvided: "कोणतीही माहिती दिलेली नाही",
  },
  tenantBrowse: {
    occBoys: "बॉईज पीजी",
    occGirls: "गर्ल्स पीजी",
    occCoEd: "को-एड पीजी",
    occDefault: "पीजी",
    filterAll: "सर्व",
    filterPg: "पीजी",
    filter1RK: "1RK",
    filter1BHK: "1BHK",
    filter2BHK: "2BHK",
    filter3BHK: "3BHK",
    filterVilla: "व्हिला",
    filterShop: "दुकान",
    filterOffice: "ऑफिस",
    filterShowroom: "शोरूम",
    filterWarehouse: "गोदाम",
    filterCoworking: "को-वर्किंग",
    filterFactory: "फॅक्टरी",
    sortDefault: "डिफॉल्ट",
    sortPriceAsc: "किंमत: कमी ते जास्त",
    sortPriceDesc: "किंमत: जास्त ते कमी",
    sortDistance: "अंतर: सर्वात जवळचे",
    locationNotSupported: "या ब्राउझरमध्ये लोकेशन सपोर्ट होत नाही",
    locationPermissionDenied: "लोकेशनची परवानगी नाकारली",
    locationCouldNotGet: "तुमचे लोकेशन मिळू शकले नाही",
    heading: "चला तुमच्यासाठी टू-लेट शोधूया",
    searchPlaceholder: "परिसर किंवा प्रॉपर्टीच्या नावाने शोधा",
    filtersBtn: "⚙ फिल्टर्स",
    listView: "☰ लिस्ट व्ह्यू",
    mapView: "🗺️ मॅप व्ह्यू",
    fromPrice: "{price} पासून",
    housesCount: "{count} घरे",
    noVacancies: "सध्या कोणतीही रिकामी जागा नाही — नंतर पुन्हा बघा.",
    noMatch: "तुमच्या शोध किंवा फिल्टरशी जुळणारी कोणतीही लिस्टिंग नाही.",
    noPinnedLocation: "यापैकी कोणत्याही लिस्टिंगचे लोकेशन पिन केलेले नाही.",
    distanceAway: "{value} दूर",
    filtersTitle: "फिल्टर्स",
    propertyTypeLabel: "प्रॉपर्टीचा प्रकार",
    sortByLabel: "यानुसार क्रमवारी लावा",
    yourLocationLabel: "तुमचे लोकेशन",
    locating: "लोकेशन शोधत आहे…",
    locationOn: "📍 लोकेशन चालू आहे",
    useMyLocation: "📍 माझे लोकेशन वापरा",
    nearLabel: "📍 {location} जवळ",
    clearAll: "सर्व क्लिअर करा",
    showResults: "निकाल दाखवा",
    backToListings: "‹ लिस्टिंगकडे परत जा",
    housesHeading: "घरे",
    occupiedBadge: "भरलेले",
    vacantBadge: "रिकामे",
    typeLabel: "प्रकार",
    rentLabel: "भाडे",
    perMonthSuffix: "/महिना",
    depositLabel: "डिपॉझिट",
    escalationLabel: "भाडेवाढ",
    yearsSuffix: "वर्षे",
    occupancyLabel: "ऑक्युपन्सी",
    mealPlanLabel: "जेवण समाविष्ट",
    preferredTenantsLabel: "पसंतीचे भाडेकरू",
    roomAc: "एसी",
    roomAttachedBathroom: "अटॅच्ड बाथरूम",
    bedsVacant: "{total} पैकी {vacant} बेड रिकामे",
    locationLabel: "लोकेशन",
    openInGoogleMaps: "Google Maps मध्ये उघडा",
    viewOnMap: "नकाशावर पहा",
    hideMap: "नकाशा लपवा",
    showNearby: "जवळपास काय आहे ते पहा",
    hideNearby: "जवळपासची ठिकाणे लपवा",
    loadingNearby: "जवळपासची ठिकाणे शोधत आहे…",
    nearbyEmpty: "जवळपास कोणतीही ठिकाणे सापडली नाहीत",
    nearbyTransit: "ट्रान्झिट",
    nearbyEssentials: "जीवनावश्यक वस्तू",
    nearbyHealthcare: "आरोग्यसेवा",
    metersAway: "{distance} मी अंतरावर",
    similarPropertiesHeading: "मिळत्याजुळत्या प्रॉपर्टीज",
    topTag: "टॉप",
    featuredTag: "फीचर्ड",
    moveInHint: "राहायला जाण्यासाठी, तुमच्या नोंदणीकृत फोन नंबरने तुम्हाला भाडेकरू म्हणून जोडायला मालकाला सांगा — मग ते आपोआप तुमच्या होम टॅबमध्ये दिसेल.",
    scheduleVisit: "व्हिजिट शेड्यूल करा",
    pickDateTime: "तारीख आणि वेळ निवडा",
    visitRequestSent: "व्हिजिट रिक्वेस्ट मालकाला पाठवली",
    couldNotSendVisit: "व्हिजिट रिक्वेस्ट पाठवता आली नाही",
    requestedFor: "{date} रोजी {time} वाजता रिक्वेस्ट पाठवली — मालकाला कळवले आहे, ते कन्फर्म करतील.",
    dateLabel: "तारीख",
    timeLabel: "वेळ",
    noteOptionalLabel: "नोंद (ऐच्छिक)",
    notePlaceholder: "उदा. संध्याकाळी आवडेल, आधी कॉल करेन",
    sending: "पाठवत आहे…",
    requestVisitBtn: "व्हिजिट रिक्वेस्ट करा",
    ownerContactLabel: "मालक",
    verifiedOwnerBadge: "व्हेरिफाईड",
    unlockingBtn: "अनलॉक होत आहे…",
    unlockNumberFreeBtn: "🔓 नंबर अनलॉक करा — मोफत",
    unlockUpsellTitle: "मोफत अनलॉक वापरले गेले",
    unlockUpsellBody: "बेसिक प्लॅनमध्ये 1 मालकाचा कॉन्टॅक्ट मोफत अनलॉक होतो. अमर्यादित मालक अनलॉक करण्यासाठी Tenant Pro मध्ये अपग्रेड करा.",
    unlockUpsellBtn: "Tenant Pro मध्ये अपग्रेड करा",
    callNumberBtn: "{phone} ला कॉल करा",
    whatsappBtn: "💬 WhatsApp वर चॅट करा",
    whatsappMessage: "नमस्कार, ToLetBook वर लिस्ट केलेल्या तुमच्या प्रॉपर्टी \"{property}\" मध्ये मला रस आहे. ती अजून उपलब्ध आहे का?",
    contactUnlockedToast: "कॉन्टॅक्ट नंबर अनलॉक झाला",
    couldNotUnlockToast: "कॉन्टॅक्ट अनलॉक होऊ शकला नाही",
  },
  tenantPayments: {
    noActiveTenancy: "भाडे भरण्यासाठी तुमची कोणतीही अ‍ॅक्टिव्ह टेनन्सी नाही.",
    title: "पेमेंट्स",
    paidStatus: "भरले",
    rentDue: "भाडे बाकी आहे",
    reminderBanner: "🔔 या पेमेंटबद्दल तुमच्या मालकाने रिमाइंडर पाठवला आहे",
    payingBtn: "भरत आहे…",
    payViaUpi: "UPI द्वारे {amount} भरा",
    payNow: "{amount} भरा",
    paymentFailedToast: "पेमेंट झाले नाही — पुन्हा प्रयत्न करा",
    paymentRecordedToast: "पेमेंट नोंदवले गेले",
    viewReceiptBtn: "पावती बघा",
    history: "इतिहास",
    payViaUpiDirectlyBtn: "थेट UPI ने भरा",
    ownerUpiIdLabel: "मालकाचा UPI ID",
    copyUpiBtn: "कॉपी करा",
    upiIdCopiedToast: "UPI ID कॉपी झाली",
    openUpiAppBtn: "UPI अ‍ॅप उघडा",
    markPaidUpiBtn: "मी UPI ने भरले आहे",
    markPaidUpiConfirm: "तुम्ही हे भाडे मालकाच्या UPI ID वर पाठवले आहे का? यामुळे ते भरले म्हणून नोंदवले जाईल.",
  },
  tenantRequests: {
    title: "मेंटेनन्स रिक्वेस्ट",
    cancelLink: "रद्द करा ›",
    newLink: "+ नवीन ›",
    whatsWrong: "काय समस्या आहे?",
    issuePlaceholder: "उदा. नळातून पाणी गळते",
    detailsOptional: "तपशील (ऐच्छिक)",
    submittingBtn: "सबमिट होत आहे…",
    submitRequestBtn: "रिक्वेस्ट सबमिट करा",
    giveTitleError: "रिक्वेस्टला शीर्षक द्या",
    requestRaisedToast: "रिक्वेस्ट पाठवली",
    noRequestsYet: "अजून कोणतीही रिक्वेस्ट पाठवलेली नाही.",
    noDetailsProvided: "कोणतीही माहिती दिलेली नाही",
    myVisitsHeading: "माझ्या व्हिजिट रिक्वेस्ट",
    emptyNoVisits: "तुम्ही अजून कोणतीही प्रॉपर्टी व्हिजिट रिक्वेस्ट केलेली नाही.",
    visitLine: "{date} रोजी {time} वाजता",
    cancelVisitButton: "रद्द करा",
    visitCancelledToast: "व्हिजिट रिक्वेस्ट रद्द केली",
    visitStatusPending: "प्रलंबित",
    visitStatusConfirmed: "कन्फर्म झाली",
    visitStatusDeclined: "नाकारली",
    visitStatusCancelled: "रद्द केली",
    vacateNoticeHeading: "रिकामी करण्याची नोटीस",
    giveNoticeLink: "+ नोटीस द्या ›",
    vacateOnLabel: "{date} रोजी रिकामी होणार",
    noticeGivenOnLabel: "{date} रोजी नोटीस दिली",
    vacateStatusPending: "प्रलंबित",
    vacateStatusAcknowledged: "मान्य केली",
    vacateStatusCancelled: "रद्द केली",
    shareWhatsappBtn: "💬 WhatsApp वर शेअर करा",
    cancelNoticeBtn: "नोटीस रद्द करा",
    noticeDateLabel: "नोटीसची तारीख",
    vacateDatePreview: "तुमच्या {days}-दिवसांच्या नोटीस कालावधीनुसार, तुम्ही {date} रोजी जागा रिकामी कराल",
    submitVacateNoticeBtn: "रिकामी करण्याची नोटीस पाठवा",
    vacateNoticeSentToast: "रिकामी करण्याची नोटीस मालकाला पाठवली",
    vacateNoticeCancelledToast: "रिकामी करण्याची नोटीस रद्द केली",
    emptyNoVacateNotices: "तुम्ही अजून कोणतीही रिकामी करण्याची नोटीस दिलेली नाही.",
    vacateWhatsappMessage: "नमस्कार {owner}, ही औपचारिक नोटीस आहे की \"{property}\" {vacateDate} रोजी रिकामी केली जाईल. नोटीस {noticeDate} रोजी दिली गेली.",
  },
  tenantOnboarding: {
    title: "तुमचा मूव्ह-इन पूर्ण करा",
    nameLabel: "तुमचे नाव (आधार प्रमाणे)",
    nameHint: "हेच नाव तुमच्या रेंटल अ‍ॅग्रीमेंटवर वापरले जाईल.",
    rentLabel: "मासिक भाडे",
    dueDayLabel: "भाडे भरण्याचा दिवस",
    dueDayValue: "दर महिन्याच्या {day} तारखेला",
    depositLabel: "सिक्युरिटी डिपॉझिट",
    depositPaidBadge: "भरले",
    depositPendingBadge: "बाकी",
    depositConfirmingBadge: "पुष्टी होत आहे…",
    payNowBtn: "आता भरा",
    payingBtn: "पेमेंट उघडत आहे…",
    depositPaymentDesc: "सिक्युरिटी डिपॉझिट",
    depositPaidToast: "डिपॉझिट पेमेंट मिळाले",
    depositFailedToast: "पेमेंट झाले नाही — पुन्हा प्रयत्न करा",
    depositPaidCashBadge: "रोखीने भरले",
    paidInCashLink: "मी रोखीने भरले",
    cashProofHint: "पावती किंवा पेमेंटचा पुरावा फोटो जोडा (ऐच्छिक).",
    cashProofUploadLabel: "पुरावा जोडा",
    confirmCashBtn: "रोख पेमेंटची पुष्टी करा",
    errDepositRequired: "पुढे जाण्यापूर्वी सिक्युरिटी डिपॉझिट भरा (ऑनलाइन किंवा रोख)",
    amenitiesLabel: "मालकाने दिलेल्या सुविधा",
    identityVerificationLabel: "ओळख पडताळणी",
    yourIdentityLabel: "तुम्ही",
    identityVerificationHint: "तुमचे सरकारी-पडताळलेले नाव भाडे कराराच्या करारावर दिसावे यासाठी DigiLocker द्वारे तुमची ओळख पडताळा.",
    confirmLabel: "मी वर दिलेली माझी मूव्ह-इन माहिती तपासली आहे आणि ती बरोबर असल्याची पुष्टी करतो/करते.",
    submitBtn: "सेटअप पूर्ण करा",
    errNameRequired: "तुमचे नाव टाका",
    errMustConfirm: "कृपया तुम्ही माहिती तपासल्याची पुष्टी करा",
    completedToast: "मूव्ह-इन माहितीची पुष्टी झाली",
  },
  moveInDetails: {
    title: "मूव्ह-इन माहिती",
  },
  locationCapture: {
    pinLocationLabel: "या प्रॉपर्टीचे लोकेशन पिन करा",
    panMapHint: "📌 योग्य ठिकाणी पिन ठेवण्यासाठी नकाशा हलवा",
    expandMapAria: "नकाशा मोठा करा",
    clear: "क्लिअर करा",
    searchPlaceholder: "पत्ता शोधा",
    loadingSearch: "सर्च लोड होत आहे…",
    or: "किंवा",
    locating: "लोकेशन शोधत आहे…",
    useCurrentLocation: "📍 सध्याचे लोकेशन वापरा",
    pickSuggestion: "ड्रॉपडाउनमधून एक सूचना निवडा",
    locationNotSupported: "या ब्राउझरमध्ये लोकेशन सपोर्ट होत नाही",
    locationPermissionDenied: "लोकेशनची परवानगी नाकारली",
    locationCouldNotGet: "तुमचे लोकेशन मिळू शकले नाही",
    hint: "पत्ता शोधा किंवा खालील परिसर आपोआप भरण्यासाठी GPS वर टॅप करा — दाराचा नंबर आणि इमारतीचे नाव तुम्हाला स्वतः टाकावे लागेल.",
  },
  googleMap: {
    yourLocation: "तुमचे लोकेशन",
    couldNotLoad: "Google Maps लोड होऊ शकले नाही — API की तपासा",
    viewDetails: "तपशील बघा ›",
  },
  rentReceipt: {
    back: "‹ मागे",
    paymentRecordedBanner: "✓ पेमेंट नोंदवले गेले — ही तुमची पावती.",
    title: "भाडे पावती",
    amountPaid: "भरलेली रक्कम",
    receiptNoLabel: "पावती क्रमांक",
    paidByLabel: "भरणारा",
    propertyLabel: "प्रॉपर्टी",
    receivedByLabel: "स्वीकारणारा",
    forMonthLabel: "कोणत्या महिन्यासाठी",
    paymentModeLabel: "पेमेंटची पद्धत",
    paidOnLabel: "भरल्याची तारीख",
    downloadBtn: "डाउनलोड करा",
    shareBtn: "शेअर करा",
    htmlTitle: "भाडे पावती - {month}",
    htmlStamp: "✓ भरले",
    htmlAmountPaidLabel: "भरलेली रक्कम",
    htmlFooter: "ही ToLetBook कडून सिस्टीम-जनरेटेड पावती आहे. इथे दाखवलेले भाडे अ‍ॅपमध्ये नोंदवलेले आहे आणि खऱ्या पेमेंट गेटवेद्वारे प्रोसेस केलेले नाही.",
    shareTitle: "भाडे पावती - {month}",
    shareText: "पावती {receiptNo}, रक्कम {amount}",
  },
  rentalAgreement: {
    back: "‹ मागे",
    title: "रेंटल अ‍ॅग्रीमेंट",
    ownerLabel: "मालक",
    tenantLabel: "भाडेकरू",
    propertyLabel: "प्रॉपर्टी",
    typeLabel: "प्रकार",
    monthlyRentLabel: "मासिक भाडे",
    securityDepositLabel: "सिक्युरिटी डिपॉझिट",
    moveInDateLabel: "राहायला आल्याची तारीख",
    disclaimer: "हा रेकॉर्डवरील टेनन्सी माहितीवरून आपोआप तयार झालेला सारांश आहे, कोणतेही कायदेशीर बंधनकारक कागदपत्र नाही. डेमोच्या नेहमीच्या अटी: दर महिन्याच्या 5 तारखेपर्यंत भाडे द्यावे, टेनन्सी संपवण्यासाठी 30 दिवसांची नोटीस, सामान्य झिजेपेक्षा जास्त नुकसानीची कपात करून डिपॉझिट परत मिळेल.",
    downloadAgreementBtn: "अ‍ॅग्रीमेंट डाउनलोड करा",
    stampStatusLabel: "E-Stamp स्टेटस",
    stampStatusNotStarted: "सुरू झाले नाही",
    stampStatusProcessing: "प्रोसेस होत आहे",
    stampStatusVerified: "व्हेरिफाईड",
    stampHint: "हा अ‍ॅग्रीमेंट सरकारकडून कायदेशीररीत्या E-Stamp करून घ्या. यासाठी {amount} ची खरी सरकारी फी लागू होते.",
    stampFeeAlreadyPaidHint: "तुमची E-Stamp फी भरली गेली आहे — फक्त ऑर्डर अजून देता आली नाही. कोणत्याही अतिरिक्त शुल्काशिवाय खाली पुन्हा प्रयत्न करा.",
    sendForStampBtn: "{amount} भरा आणि E-Stamp साठी पाठवा",
    retrySendForStampBtn: "E-Stamp साठी पुन्हा पाठवा",
    sendingStampBtn: "पाठवत आहे…",
    confirmingPaymentBtn: "पेमेंटची पुष्टी होत आहे…",
    stampFeePaymentDesc: "सरकारी E-Stamp फी",
    stampFeeFailedToast: "पेमेंट अयशस्वी झाले — पुन्हा प्रयत्न करा",
    stampSentToast: "सरकारी E-Stamping साठी पाठवले",
    refreshStatusBtn: "स्टेटस रिफ्रेश करा",
    viewStampedBtn: "स्टॅम्प केलेला अ‍ॅग्रीमेंट पहा",
    identityVerificationLabel: "ओळख पडताळणी",
    digilockerVerifiedBadge: "पडताळणी झाली",
    digilockerNotVerifiedBadge: "पडताळणी झाली नाही",
    verifyDigilockerBtn: "DigiLocker ने पडताळणी करा",
    verifyingDigilockerBtn: "DigiLocker उघडत आहे…",
    digilockerVerifiedToast: "{name} म्हणून पडताळणी झाली",
    digilockerDeniedToast: "DigiLocker पडताळणी रद्द केली",
    digilockerExpiredToast: "ती DigiLocker लिंक कालबाह्य झाली — पुन्हा प्रयत्न करा",
    comingSoonTitle: "सरकारी ई-स्टॅम्पिंग लवकरच येत आहे",
    comingSoonBody: "तुम्ही अ‍ॅपमधूनच पूर्णपणे सरकार-सत्यापित, ई-स्टॅम्प्ड भाडे करार तयार करू शकाल यासाठी आम्ही स्टॅम्प ड्युटी पेमेंट सेट करत आहोत.",
    interestBtn: "मला रस आहे — कळवा",
    interestRegisteredBtn: "तुम्ही यादीत आहात ✓",
    interestToast: "धन्यवाद! ई-स्टॅम्पिंग लाइव्ह झाल्यावर आम्ही तुम्हाला कळवू.",
    uploadDocHeading: "आधीच भाडे करार आहे का?",
    uploadDocHint: "तुम्ही ToLetBook च्या बाहेर आधीच एक बनवला असेल, तर या भाडेकरारासोबत सेव्ह होण्यासाठी येथे अपलोड करा.",
    uploadDocBtn: "भाडे करार अपलोड करा",
    viewUploadedDocBtn: "अपलोड केलेला करार पहा",
    removeUploadedDocBtn: "काढा",
    uploadedOnLabel: "{date} रोजी अपलोड केले",
    noUploadedDocTenantHint: "तुमच्या मालकाने अजून भाडे करार अपलोड केलेला नाही.",
    uploadDocSuccessToast: "भाडे करार अपलोड झाला",
    uploadDocFailedToast: "अपलोड करता आले नाही — 8MB पेक्षा कमी आकाराचा PDF किंवा इमेज वापरून पहा",
    removeDocConfirm: "अपलोड केलेला भाडे करार काढायचा का?",
    removeDocSuccessToast: "भाडे करार काढला",
    htmlTitle: "रेंटल अ‍ॅग्रीमेंट - {property}",
    htmlDocTitle: "रेंटल अ‍ॅग्रीमेंट सारांश",
    htmlAgreementNo: "अ‍ॅग्रीमेंट क्रमांक {no}",
    htmlOwnerLessor: "मालक / लेसर",
    htmlTenantLessee: "भाडेकरू / लेसी",
    htmlPropertyHeading: "प्रॉपर्टी",
    htmlAddressLabel: "पत्ता",
    htmlTypeLabel: "प्रकार",
    htmlTermsHeading: "अटी",
    htmlMonthlyRentLabel: "मासिक भाडे",
    htmlSecurityDepositLabel: "सिक्युरिटी डिपॉझिट",
    htmlMoveInDateLabel: "राहायला आल्याची तारीख",
    htmlConditionsHeading: "नियम",
    htmlCond1: "प्रत्येक महिन्याच्या 5 तारखेपर्यंत, ठरलेल्या पद्धतीने भाडे मालकाला द्यावे.",
    htmlCond2: "सामान्य झिजेपेक्षा जास्त नुकसानीची कपात करून, जागा सोडताना सिक्युरिटी डिपॉझिट परत मिळेल.",
    htmlCond3: "टेनन्सी संपवण्यापूर्वी दोन्ही पक्षांपैकी कोणालाही किमान 30 दिवसांची लेखी नोटीस द्यावी लागेल.",
    htmlCond4: "मालकाशी वेगळे ठरल्याशिवाय, युटिलिटी बिलांची जबाबदारी भाडेकरूची असेल.",
    htmlCond5: "भाडेकरूच्या निष्काळजीपणामुळे नुकसान झाले नसेल तर, फिक्स्चर आणि फिटिंग्जच्या देखभालीची जबाबदारी मालकाची असेल.",
    htmlFooter: "हा सारांश ToLetBook द्वारे रेकॉर्डवरील टेनन्सी माहितीवरून आपोआप तयार केला आहे आणि हे कोणतेही कायदेशीर बंधनकारक कागदपत्र नाही. औपचारिक रेंटल अ‍ॅग्रीमेंट तयार करण्यासाठी कायदेतज्ज्ञाचा सल्ला घ्या.",
  },
  photoLightbox: {
    closeAria: "बंद करा",
    previousPhotoAria: "मागील फोटो",
    nextPhotoAria: "पुढील फोटो",
    countLabel: "{current} / {total}",
  },
  tenantPlan: {
    title: "प्लॅन",
    currentPlanLabel: "सध्याचा प्लॅन",
    basicName: "बेसिक",
    proName: "भाडेकरू प्रो",
    proSub: "सक्रियपणे घर शोधणाऱ्या भाडेकरूंसाठी",
    priceValidity: "1 महिन्यासाठी वैध",
    featUnlock: "30 दिवसांसाठी अमर्यादित मालकाचे संपर्क नंबर अनलॉक करा",
    featNearby: "प्रत्येक लिस्टिंगवर पूर्ण मॅप आणि जवळपासच्या ठिकाणांचा अ‍ॅक्सेस",
    featWhatsapp: "मालकाशी थेट WhatsApp वर बोला, प्रति-लिस्टिंग फी नाही",
    featFallback: "सबस्क्राइब न केल्यासही 1 मालकाचा कॉन्टॅक्ट मोफत अनलॉक मिळतो — त्यानंतर अपग्रेड करावे लागेल",
    currentPlanBtn: "सध्याचा प्लॅन",
    subscribeBtn: "₹99 मध्ये सबस्क्राइब करा",
    activeUntil: "{date} पर्यंत अ‍ॅक्टिव्ह",
    noChargeNote: "अजून पेमेंटची गरज नाही — बिलिंग सेट होईपर्यंत सबस्क्राइब करणे मोफत आहे.",
    subscribedToast: "भाडेकरू प्रो अ‍ॅक्टिव्हेट झाले",
    switchFailedToast: "तुमचा प्लॅन अपडेट करता आला नाही",
    nearbyUpsellTitle: "मॅप आणि जवळपासची ठिकाणे अनलॉक करा",
    nearbyUpsellBody: "प्रत्येक लिस्टिंगजवळ ट्रान्झिट, जीवनावश्यक सुविधा आणि हेल्थकेअर पाहण्यासाठी भाडेकरू प्रो सबस्क्राइब करा.",
    nearbyUpsellBtn: "भाडेकरू प्रो पहा",
    cancelPlanBtn: "प्लॅन रद्द करा",
    securePaymentNote: "पेमेंट Razorpay द्वारे सुरक्षितपणे प्रोसेस केले जाते.",
    cancelledToast: "भाडेकरू प्रो रद्द केला",
  },
};
